export default "__VITE_ASSET__BzlgcHs1__"